<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

  <ng-container *ngIf="consulta">

    <div class="body">
      <ng-container *ngFor="let r of consulta?.registros; let i = index">
        <h2 class="subtitle subtitle-{{status}}">PROTESTO {{i+1}}</h2>
        <ul class="card-list-striped py-1">
          <li>
            <span class="text-secondary">CARTÓRIO:</span>
            <span class="text-uppercase">{{ r?.cartorio || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">DATA:</span>
            <span class="text-uppercase">{{ r?.data || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">NATUREZA:</span>
            <span class="text-uppercase">{{ r?.natureza || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">CIDADE:</span>
            <span class="text-uppercase">{{ r?.cidade || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">UF:</span>
            <span class="text-uppercase">{{ r?.uf || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">VALOR:</span>
            <span class="text-uppercase"> {{r?.moeda || '' }} {{ r?.valor || msgNull }}</span>
          </li>
        </ul>
      </ng-container>

    </div>

  </ng-container>

</app-card-consulta>